module.exports = __webpack_public_path__ + "static/media/Trazado 9243@2x.40111726.png";